<template>
  <div class="vc-form-group-control">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'vc-form-control'
}
</script>

<style scoped lang="less">
  .vc-form-group-control {
    height: 100%;
  }
</style>
